import { baseKeymap } from 'prosemirror-commands';
import { dropCursor } from 'prosemirror-dropcursor';
import { gapCursor } from 'prosemirror-gapcursor';
import { history } from 'prosemirror-history';
import { keymap } from 'prosemirror-keymap';
import { Schema } from 'prosemirror-model';

import { inputRules } from './inputrules';
import { buildKeymap } from './keymap';
import { menu, MenuOptions } from './menus';
import { plugins } from './plugins';

export type ProseMirrorSetupOptions = MenuOptions;

export function setup(schema: Schema, options: ProseMirrorSetupOptions) {
  return [
    inputRules(schema),
    keymap(buildKeymap(schema, {})),
    keymap(baseKeymap),
    dropCursor(),
    gapCursor(),
    menu(schema, options),
    history(),
    ...plugins(schema),
  ];
}
